import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { Y42FeatureType } from '@y42/json-schema';
import { Y42FeatureTypeToChildLogo } from '../../models';

@Component({
  selector: 'y42-feature-type-child-icon[featureType]',
  templateUrl: './feature-type-child-icon.component.html',
  styleUrls: ['./feature-type-child-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureTypeChildIconComponent implements OnChanges {
  @Input() featureType!: Y42FeatureType;
  @Input() customClasses?: string[];
  iconPath?: string | null;

  ngOnChanges(): void {
    this.iconPath = Y42FeatureTypeToChildLogo[this.featureType] || null;
  }
}
